import { IconProps } from "../../utils/global-types/global-types";

const BoldIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_9118_136735)">
        <path
          fill="currentColor"
          d="M3.59 16V2H8.4q2.606 0 4.067.966 1.461.967 1.461 2.88 0 1-.47 1.78-.472.778-1.453 1.172 1.23.28 1.818 1.12.585.841.586 1.938 0 2.048-1.375 3.096T9.091 16zm3.26-8.163h1.616q1.105-.02 1.654-.428.548-.41.548-1.197 0-.894-.558-1.303-.558-.41-1.711-.409H6.85zm0 2.153v3.51h2.24q1.039 0 1.559-.409.519-.408.519-1.254 0-.915-.447-1.38-.447-.467-1.447-.467z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_9118_136735">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default BoldIcon;
